import { useState } from 'react';

import { IconButton, Tooltip } from '@/components';
import { FileCheckIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { SpellCheckInstructionView } from './SpellCheckInstructionView';

type LabelWithSpellCheckProps = {
    label?: string;
};

export const LabelWithSpellCheck = ({ label }: LabelWithSpellCheckProps) => {
    const [showInstruction, setShowInstruction] = useState(false);

    return (
        <>
            {label}
            <IconButton
                tooltip={R.SpellCheckTooltip}
                tooltipDirection="top"
                maxTooltipWidth="160px"
                allowTooltipTextWrap={true}
                onClick={() => setShowInstruction(true)}
                icon={<FileCheckIcon variant="action" />}
            />
            {showInstruction && (
                <SpellCheckInstructionView
                    onClose={() => setShowInstruction(false)}
                />
            )}
        </>
    );
};
